/* A Granel: warm product documents only after real navigation intent. */
(function productDocumentPrefetch() {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var MAX_DOCUMENTS = 3, HOVER_DELAY = 120;
  var reservedUrls = new Set(), pendingHoverTimers = new Map(), prefetchedCount = 0;
  function isDesignMode() {
    return Boolean((window.Shopify && window.Shopify.designMode) || (document.documentElement && document.documentElement.classList.contains('shopify-design-mode')));
  }
  function isNetworkConstrained() {
    var connection = typeof navigator !== 'undefined' && navigator.connection;
    if (!connection) return false;
    return Boolean(connection.saveData || connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g');
  }
  function canPrefetch() { return !document.hidden && !isDesignMode() && !isNetworkConstrained(); }
  function productUrlFromAnchor(anchor) {
    if (!anchor || !anchor.href || anchor.hasAttribute('download')) return null;
    if (anchor.target && anchor.target !== '_self') return null;
    var url;
    try { url = new URL(anchor.href, window.location.href); } catch (error) { return null; }
    if (url.origin !== window.location.origin || url.protocol !== window.location.protocol) return null;
    var path = url.pathname;
    if (!(/^\/products\/[^/]+\/?$/.test(path) || /^\/collections\/(?:[^/]+\/)*products\/[^/]+\/?$/.test(path))) return null;
    url.hash = '';
    var current = new URL(window.location.href); current.hash = '';
    if (url.origin + url.pathname + url.search === current.origin + current.pathname + current.search) return null;
    return url.href;
  }
  function supportsSpeculationRules() {
    try { return Boolean(window.HTMLScriptElement && typeof window.HTMLScriptElement.supports === 'function' && window.HTMLScriptElement.supports('speculationrules')); } catch (error) { return false; }
  }
  function addSpeculationPrefetch(url) {
    var rule = document.createElement('script'); rule.type = 'speculationrules';
    rule.textContent = JSON.stringify({prefetch: [{source: 'list', urls: [url]}]}); document.head.appendChild(rule);
  }
  function addLinkPrefetch(url) {
    var link = document.createElement('link'); link.rel = 'prefetch'; link.href = url;
    link.setAttribute('fetchpriority', 'low'); link.setAttribute('data-ag-product-prefetch', ''); document.head.appendChild(link);
  }
  function prefetch(url) {
    if (!url || prefetchedCount >= MAX_DOCUMENTS || reservedUrls.has(url) || !canPrefetch()) return;
    reservedUrls.add(url); prefetchedCount += 1;
    if (supportsSpeculationRules()) addSpeculationPrefetch(url); else addLinkPrefetch(url);
  }
  function anchorForEvent(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return null; return target.closest('a[href]');
  }
  function isInside(anchor, node) { return Boolean(node && (node === anchor || (anchor.contains && anchor.contains(node)))); }
  function queueHover(anchor) {
    if (!anchor || pendingHoverTimers.has(anchor)) return;
    var timer = window.setTimeout(function () { pendingHoverTimers.delete(anchor); prefetch(productUrlFromAnchor(anchor)); }, HOVER_DELAY); pendingHoverTimers.set(anchor, timer);
  }
  function cancelHover(anchor) {
    var timer = pendingHoverTimers.get(anchor); if (timer === undefined) return; window.clearTimeout(timer); pendingHoverTimers.delete(anchor);
  }
  document.addEventListener('pointerover', function (event) {
    var anchor = anchorForEvent(event); if (!anchor || isInside(anchor, event.relatedTarget)) return; queueHover(anchor);
  }, {passive: true});
  document.addEventListener('pointerout', function (event) {
    var anchor = anchorForEvent(event); if (!anchor || isInside(anchor, event.relatedTarget)) return; cancelHover(anchor);
  }, {passive: true});
  document.addEventListener('focusin', function (event) {
    var anchor = anchorForEvent(event); if (!anchor) return; prefetch(productUrlFromAnchor(anchor));
  });
  document.addEventListener('pointerdown', function (event) {
    var anchor = anchorForEvent(event); if (!anchor) return; cancelHover(anchor); prefetch(productUrlFromAnchor(anchor));
  }, {passive: true, capture: true});
}());
